import React from 'react';
import { Images, PermissionList, RolePermission } from 'utils';
import {
    DateRow,
    DateRowStartEnd,
    EditWithIcon,
    LinkRow,
    MinLoader,
    PriceInput,
    PriceRow,
    RemoveClaim,
    renderCptCodeAndModifiers,
    SimpleTooltip,
    TextRow,
    UnitsRow,
} from 'components';
import { claimEnums } from 'utils';
import { SubmittedClaimStatus } from '../../claim/core/submittedClaimStatus';
import { ClaimAdjustmentCell } from '../../claim/core';
import { OpenClaimDetails } from '../../claim/openClaimDetails';

export const claimPaymentTableInfo = (
    classes,
    handleAction,
    handleChange,
    currentInput,
    activeRow,
    inputs,
    loadSave,
    checkError,
    afterSuccess
) => {
    const style = {
        height: '36px',
        borderBottom: `1px solid ${activeRow ? '#347AF0' : '#D8E5FF'}`,
    };

    const styleNoBorder = {
        height: '36px',
        borderBottom: `1px solid #FE7070`,
    };

    return {
        // loadingType: 'GET_CLAIM_PAYMENTS',
        loadingType: 'GET_CLAIM_PAYMENT_FILTERED',
        head: [
            { name: 'displayId', title: 'Claim ID', noSearch: true, width: '9%' },
            { name: 'dateRange', title: 'DOS', noSearch: true, custom: false, width: '6%' },
            { name: 'client', title: 'Client', noSearch: true, width: '9%' },
            { name: 'billedAmt', title: 'Total Billed', noSearch: true, iconType: 'date', width: '9%' },
            { name: 'paidAmt', title: 'Total Paid', noSearch: true, iconType: 'date', width: '9%' },
            { name: 'balance', title: 'Balance', noSearch: true, custom: false, width: '9%' },
            { name: 'aging', title: 'Aging', noSearch: true, iconType: 'date', width: '6%' },
            { name: 'status', title: 'Status', noSearch: true, custom: false, width: '16%' },
            { name: 'actions', title: '   ', noSearch: true, custom: false, width: '25%' },
        ],

        body: (item) => {
            return [
                {
                    value: (
                        <OpenClaimDetails claimId={item?.id} displayId={item?.displayId} afterSuccess={afterSuccess} />
                        // <LinkRow
                        //     name={item?.displayId ? item?.displayId : '--'}
                        //     href={RolePermission([PermissionList.CLAIMS_READ?.code]) ? `/billedClaim/${item?.id}` : ''}
                        //     checkPermission={item?.displayId ? RolePermission([PermissionList.CLAIMS_READ?.code]) : null}
                        // />
                    ),
                    width: '9%',
                },
                { value: <DateRowStartEnd start={item?.dos?.early} end={item?.dos?.latest} secondLine={true} />, width: '6%' },
                {
                    value: (
                        <LinkRow
                            name={item?.clientFullName ? item.clientFullName : '--'}
                            href={RolePermission([PermissionList.CLIENT_READ?.code]) ? `/client/${item?.clientId}` : ''}
                            checkPermission={item?.clientId ? RolePermission([PermissionList.CLIENT_READ?.code]) : null}
                        />
                    ),
                    notClickable: true,
                    width: '9%',
                },

                { value: <PriceRow info={item?.billedAmount ? item?.billedAmount : 0} />, width: '9%' },
                { value: <PriceRow info={item?.paidAmount ? item?.paidAmount : 0} />, width: '9%' },
                { value: <PriceRow info={item?.remaining ? item?.remaining : 0} />, width: '9%' },
                { value: item?.aging ? item?.aging : '--', padding: '0', width: '6%' },
                { value: <SubmittedClaimStatus info={item} noAction={true} />, width: '16%' },

                {
                    value: (
                        <div>
                            <div className={classes.claimPaymentBodyHeadItemButtons} style={{ justifyContent: 'flex-end', gap: 16 }}>
                                {
                                    activeRow === item?.id ? (
                                        <div className={classes.buttonsWrapper}>
                                            <button onClick={() => handleAction(item, 'save')} className="save-btn-box">
                                                {loadSave?.length ? (
                                                    <MinLoader margin={'0'} color={'#344054'} position="relative" />
                                                ) : (
                                                    'Save'
                                                )}
                                            </button>
                                            <button onClick={() => handleAction(item, 'close')} className="posting-close-btn">
                                                <img src={Images.remove} alt="icon" />
                                            </button>
                                        </div>
                                    ) : (
                                        RolePermission([PermissionList.CLAIM_PMT_PAY?.code]) && (
                                            <EditWithIcon
                                                id={'secondary-billing'}
                                                icon={Images.edit}
                                                type={'button'}
                                                handleClick={() => {
                                                    handleAction(item, 'edit');
                                                }}
                                            />
                                        )
                                    )
                                    // <button
                                    //     style={{height: 36}}
                                    //     onClick={() => handleAction(item, 'edit')}
                                    //     className={classes.editButton}
                                    // >
                                    //     <img src={Images.edit} alt="edit" />
                                    // </button>
                                }

                                {RolePermission([PermissionList.CLAIM_PMT_PAY?.code]) && (
                                    <button
                                        style={{ height: 36, margin: 0 }}
                                        className={classes.payInFull}
                                        onClick={() => handleAction(item, 'payInFull')}>
                                        Pay in Full
                                    </button>
                                )}

                                {RolePermission([PermissionList.CLAIM_PMT_SEND_APPEAL?.code]) && item?.status !== claimEnums.APPEAL && (
                                    <button style={{ height: 36 }} onClick={() => handleAction(item, 'appeal')} className={classes.appeal}>
                                        Appeal
                                    </button>
                                )}

                                {/*{(item?.status === claimEnums.OPEN || item?.status === claimEnums.APPEAL) && (*/}
                                {/*    <EditWithIcon*/}
                                {/*        id={'secondary-billing'}*/}
                                {/*        icon={renderSecondaryBillingImage(item?.secondaryBilling)}*/}
                                {/*        type={'button'}*/}
                                {/*        handleClick={() => {*/}
                                {/*            handleAction(item, 'secondaryBilling');*/}
                                {/*        }}*/}
                                {/*    />*/}
                                {/*)}*/}

                                {RolePermission([PermissionList.CLAIM_PMT_SEND_APPEAL?.code]) && item?.status === claimEnums.APPEAL && (
                                    <div className="flex-align-center" style={{ gap: 16 }}>
                                        <RemoveClaim claim={item} afterSuccess={afterSuccess} />
                                        <SimpleTooltip title={<p>{item?.appealDetails}</p>} placement="top-end">
                                            <img src={Images.aboutInformation} alt="icon" />
                                        </SimpleTooltip>
                                    </div>
                                )}
                            </div>
                        </div>
                    ),
                    notClickable: true,
                    width: '25%',
                },
            ];
        },

        renderAccordionRow: (i) => i?.bills,

        accordionHead: [
            { title: 'Bill ID', width: '8%' },
            { title: 'DOS', width: '7%' },
            { title: 'CPT Code (Mod.)', width: '9%' },
            { title: 'Units', width: '5%' },
            { title: 'Billed ', width: '7%' },
            { title: 'Allowed ', width: '7%' },
            { title: 'Deduct.', width: '7%' },
            { title: 'Copay', width: '7%' },
            { title: 'CoINS', width: '7%' },
            { title: 'Paid ', width: '7%' },
            { title: 'Prev. Paid ', width: '7%' },
            { title: 'Balance ', width: '7%' },
            { title: 'Adjustments', width: '5%' },
            RolePermission([PermissionList.CLAIM_PMT_PAY?.code, PermissionList.CLAIM_PMT_SEND_APPEAL?.code]) && {
                title: 'Action',
                width: '8%',
            },
        ],

        accordionBody: (i, j, parent) => {
            return [
                { value: <TextRow name={i?.displayId ? i?.displayId : '--'} />, width: '8%' },
                { value: <DateRow date={i?.dos} />, width: '7%' },
                {
                    value: <TextRow name={renderCptCodeAndModifiers(i?.cptCode, i?.chargeRateModifier, i?.chargeRateModifier2, i?.chargeRateModifier3, i?.posModifier)} />,
                    width: '9%',
                },
                { value: <UnitsRow info={i?.totalUnits} />, width: '5%' },
                { value: <PriceRow info={i?.totalBilled} />, width: '7%' },
                {
                    value: (
                        <div style={{ ...style }} className={classes.bodyItemBodyRow}>
                            <PriceInput
                                ref={currentInput}
                                placeholder={'$0.00'}
                                name={'allowedAMT'}
                                handleChange={(e) => handleChange(e, j, i)}
                                value={
                                    activeRow
                                        ? inputs[j]?.allowedAMT === 0
                                            ? 0
                                            : inputs[j]?.allowedAMT
                                        : i?.allowedAMT
                                        ? i?.allowedAMT
                                        : 0
                                }
                                disabled={!activeRow}
                                decimalScale={2}
                                // disabled={!activeRow}
                            />
                        </div>
                    ),
                    width: '7%',
                    padding: '0',
                },
                {
                    value: (
                        <div style={checkError ? { ...styleNoBorder } : { ...style }} className={classes.bodyItemBodyRow}>
                            <PriceInput
                                ref={currentInput}
                                placeholder={'$0.00'}
                                name={'deductible'}
                                handleChange={(e) => handleChange(e, j, i)}
                                value={
                                    activeRow
                                        ? inputs[j]?.deductible === 0
                                            ? 0
                                            : inputs[j]?.deductible
                                        : i?.deductible
                                        ? i?.deductible
                                        : 0
                                }
                                disabled={!activeRow}
                                decimalScale={2}
                                // disabled={!activeRow}
                            />
                        </div>
                    ),
                    width: '7%',
                    padding: '0',
                },
                {
                    value: (
                        <div style={checkError ? { ...styleNoBorder } : { ...style }} className={classes.bodyItemBodyRow}>
                            <PriceInput
                                ref={currentInput}
                                placeholder={'$0.00'}
                                name={'copay'}
                                handleChange={(e) => handleChange(e, j, i)}
                                value={activeRow ? (inputs[j]?.copay === 0 ? 0 : inputs[j]?.copay) : i?.copay ? i?.copay : 0}
                                disabled={!activeRow}
                                decimalScale={2}
                                // disabled={!activeRow}
                            />
                        </div>
                    ),
                    width: '7%',
                    padding: '0',
                },
                {
                    value: (
                        <div style={checkError ? { ...styleNoBorder } : { ...style }} className={classes.bodyItemBodyRow}>
                            <PriceInput
                                ref={currentInput}
                                placeholder={'$0.00'}
                                name={'coIns'}
                                handleChange={(e) => handleChange(e, j, i)}
                                value={activeRow ? (inputs[j]?.coIns === 0 ? 0 : inputs[j]?.coIns) : i?.coIns ? i?.coIns : 0}
                                disabled={!activeRow}
                                decimalScale={2}
                                // disabled={!activeRow}
                            />
                        </div>
                    ),
                    width: '7%',
                    padding: '0',
                },
                {
                    value: (
                        <div style={checkError ? { ...styleNoBorder } : { ...style }} className={classes.bodyItemBodyRow}>
                            <PriceInput
                                ref={currentInput}
                                placeholder={'$0.00'}
                                name={'paidAMT'}
                                handleChange={(e) => handleChange(e, j, i)}
                                value={
                                    activeRow ? (inputs[j]?.paidAMT === 0 ? 0 : inputs[j]?.paidAMT) : i?.paidByThis ? i?.paidByThis : 0
                                    // : inputs[j]?.paidAMT : i?.payorPaid ? i?.payorPaid : 0
                                }
                                // value={
                                //     activeRow ? inputs[j]?.paidAMT === 0 ? 0 :
                                //         inputs[j]?.paidAMT : 0
                                //     // i?.payorPaid ? i?.payorPaid : 0
                                // }
                                disabled={!activeRow}
                                decimalScale={2}
                                // disabled={!activeRow}
                            />
                        </div>
                    ),
                    width: '7%',
                    padding: '0',
                },
                { value: <PriceRow info={i?.payorPaid} />, width: '7%' },
                { value: <PriceRow info={i?.payorBalance} />, width: '7%' },
                {
                    value: <ClaimAdjustmentCell claim={parent} item={i} afterSuccess={() => afterSuccess('noLoad')} />,
                    notClickable: true,
                    width: '5%',
                },
                {
                    value: (
                        <div className={classes.bodyItemBodyRow} style={{ padding: 0 }}>
                            {i?.claimStatus === claimEnums.COMPLETE ? (
                                <div className={classes.paidStatus}>
                                    <img src={Images.darkGrayDone} alt="mark" />
                                    <p>Paid</p>
                                </div>
                            ) : (
                                RolePermission([PermissionList.CLAIM_PMT_PAY?.code]) && (
                                    <button className={classes.payInFullBill} onClick={() => handleAction(i, 'payInFullBill', parent)}>
                                        Pay This Bill
                                    </button>
                                )
                            )}
                        </div>
                    ),
                    width: '10%',
                },
            ];
        },

        noDetailsText: 'No bills yet',
        notYet: {
            title: 'No Billable Appts',
            subTitle: 'There are no billable appts.',
            image: Images.noPendingClaim,
        },
    };
};



/**
 * ERA Validation Flags — shared enums + flag catalog.
 *
 * Flags are system-generated during ERA (835) ingestion (see api `ingestERA.service.ts`)
 * and surfaced read-only on each claim payment (remittance). The catalog holds the default
 * title/description/severity per code; an individual flag may add context (service line,
 * claim link, DOS, detail) and override severity/description.
 */

export const eraFlagSeverityEnums = {
    ERROR: 'error',
    WARNING: 'warning',
};

export const eraFlagCodeEnums = {
    UNMATCHED_CLAIM: 'UNMATCHED_CLAIM',
    DUPLICATE_ERA: 'DUPLICATE_ERA',
    NEGATIVE_PAYMENT: 'NEGATIVE_PAYMENT',
    PARTIAL_MATCH: 'PARTIAL_MATCH',
    UNMATCHED_LINE: 'UNMATCHED_LINE',
    MISSING_ALLOWED: 'MISSING_ALLOWED',
    ZERO_PAY: 'ZERO_PAY',
};

const { ERROR, WARNING } = eraFlagSeverityEnums;

// Default presentation per flag code. `code` is the raw chip label shown next to the title.
export const ERA_FLAG_CATALOG = {
    [eraFlagCodeEnums.UNMATCHED_CLAIM]: {
        title: 'Unmatched Claim',
        severity: ERROR,
        description: 'Claim referenced in the ERA was not found in the system.',
    },
    [eraFlagCodeEnums.DUPLICATE_ERA]: {
        title: 'Duplicate ERA',
        severity: ERROR,
        description: 'An ERA with the same payer, check number and amount has already been ingested.',
    },
    [eraFlagCodeEnums.NEGATIVE_PAYMENT]: {
        title: 'Negative Payment',
        severity: ERROR,
        description: 'The claim payment contains a negative paid amount (recoupment or reversal).',
    },
    [eraFlagCodeEnums.PARTIAL_MATCH]: {
        title: 'Partial Match',
        severity: WARNING,
        description: 'Some service lines from the ERA matched the claim, but others could not be reconciled.',
    },
    [eraFlagCodeEnums.UNMATCHED_LINE]: {
        title: 'Unmatched Service Line',
        severity: WARNING,
        description: 'One or more service lines in the ERA do not match any line on the corresponding claim.',
    },
    [eraFlagCodeEnums.MISSING_ALLOWED]: {
        title: 'Missing Allowed Amount',
        severity: WARNING,
        description: 'One or more service lines are missing an allowed amount required for reconciliation.',
    },
    [eraFlagCodeEnums.ZERO_PAY]: {
        title: 'Zero Pay',
        severity: WARNING,
        description: 'Total paid amount on this claim payment is $0.',
    },
};

// Merge a raw flag with its catalog defaults.
export const resolveEraFlag = (flag) => {
    const meta = ERA_FLAG_CATALOG[flag?.code] || {};
    return {
        ...meta,
        ...flag,
        severity: flag?.severity || meta.severity || eraFlagSeverityEnums.WARNING,
        title: flag?.title || meta.title || flag?.code,
        description: flag?.description || meta.description || '',
    };
};
